import React, {createContext} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {configure} from "mobx";

configure({
    enforceActions: "never",
});

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// safari hacks
window.addEventListener('scroll', (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
});
export const canHover = !(matchMedia('(hover: none)').matches);
if (canHover) {
    document.body.classList.add('can-hover');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
